import React from 'react';

import { Headline } from '@xingternal/typography';

import { LinkList } from './LinkList';
import styles from './Footer.css';

const formatItems = (
  intl,
  {
    memberships,
    companyLinks,
    resourcesLinks,
    appLinks,
    mainSectionsLinks,
    servicesLinks,
  }
) =>
  [
    Boolean(companyLinks.length) && {
      header: (
        <Headline size="small" as="p" className={styles.title}>
          {intl &&
            intl.formatMessage({ id: 'VERTICAL_NAVIGATION_FOOTER_COMPANY' })}
        </Headline>
      ),
      content: <LinkList data={companyLinks} />,
    },
    Boolean(resourcesLinks.length) && {
      header: (
        <Headline size="small" as="p" className={styles.title}>
          {intl &&
            intl.formatMessage({ id: 'VERTICAL_NAVIGATION_FOOTER_RESOURCES' })}
        </Headline>
      ),
      content: <LinkList data={resourcesLinks} />,
    },
    Boolean(memberships.length) && {
      header: (
        <Headline size="small" as="p" className={styles.title}>
          {intl &&
            intl.formatMessage({
              id: 'VERTICAL_NAVIGATION_FOOTER_MEMBERSHIPS',
            })}
        </Headline>
      ),
      content: <LinkList data={memberships} />,
    },
    Boolean(appLinks.length) && {
      header: (
        <Headline size="small" as="p" className={styles.title}>
          {intl &&
            intl.formatMessage({ id: 'VERTICAL_NAVIGATION_FOOTER_APPS' })}
        </Headline>
      ),
      content: <LinkList data={appLinks} external />,
    },
    Boolean(mainSectionsLinks.length) && {
      header: (
        <Headline size="small" as="p" className={styles.title}>
          {intl.formatMessage({ id: 'VERTICAL_NAVIGATION_FOOTER_YOUR_XING' })}
        </Headline>
      ),
      content: <LinkList data={mainSectionsLinks} />,
    },
    Boolean(servicesLinks.length) && {
      header: (
        <Headline size="small" as="p" className={styles.title}>
          Services
        </Headline>
      ),
      content: <LinkList data={servicesLinks} />,
    },
  ].filter(Boolean);

export { formatItems };
